import { useState } from "react";
import { Box } from "@mui/material";

import BszSectionCard from "../BszSectionCard";
import { useBszFinderContext } from "../../../context/bszContext";
import { useAppContext } from "../../../../../2_ksbHub/context/appContext";
import useReservationsSearch from "./hooks/useReservationsSearch";
import BszReservationSearch from "./components/BszReservationSearch";
import BszReservationList from "./components/BszReservationList";
/**
 * =========================================================
 * ✅ WO IST SECTION
 * =========================================================
 */
export default function BszWoIstSection() {
  const { rooms, serverNow, isABszAdmin } = useBszFinderContext();
  const { isAStudent, isATeacher } = useAppContext();

  const [query, setQuery] = useState("");

  const { allReservations, result } = useReservationsSearch(rooms, query);

  /**
   * =========================================================
   * ✅ TIME HELPER
   * =========================================================
   */
  const getRemainingMinutes = (endTime) => {
    if (!endTime || !serverNow) return null;

    const diff = Math.max(0, endTime - serverNow);
    return Math.floor(diff / 60000);
  };
  const canShowTime = (reservation) =>
    isABszAdmin || isATeacher || (isAStudent && reservation.type === "Schüler");

  return (
    <BszSectionCard title="Wo ist …?" defaultExpanded={false}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <BszReservationSearch
          hasReservations={allReservations.length > 0}
          query={query}
          onChange={setQuery}
        />

        {query && (
          <BszReservationList
            reservations={result}
            getRemainingMinutes={getRemainingMinutes}
            canShowTime={canShowTime}
          />
        )}
      </Box>
    </BszSectionCard>
  );
}
